import React, { useEffect, useRef, useState } from "react";
import { Dropdown, Offcanvas } from "react-bootstrap";
import { Link, useLocation } from "react-router-dom";
import { HashLink } from "react-router-hash-link";
import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
import "./headernew.scss";

gsap.registerPlugin(ScrollTrigger);

const Headernew = () => {
    const location = useLocation();
    const [activeSection, setActiveSection] = useState("");
    const [show, setShow] = useState(false);

    const navbarRef = useRef(null);
    const logoRef = useRef(null);
    const newLogoRef = useRef(null);
    const navLinksRef = useRef(null);
    const newLogoRefRotate = useRef(null);

    const handleShow = () => setShow(true);
    const handleClose = () => setShow(false);

    useEffect(() => {
        if (window.matchMedia("(min-width: 1400px)").matches) {
            const ctx = gsap.context(() => {
                gsap.set(navbarRef.current, {
                    width: "100vw",
                    left: "0%",
                    x: "0%",
                });

                gsap.set(navLinksRef.current, {
                    justifyContent: "center",
                });

                gsap.set(newLogoRef.current, {
                    x: 40,
                    opacity: 0,
                    width: 0,
                });

                const scrollConfig = {
                    trigger: "#page-scroll-target",
                    start: "top top",
                    end: "+=300",
                    toggleActions: "play none none reverse",
                    immediateRender: false,
                    anticipatePin: 1,
                };

                gsap.fromTo(
                    logoRef.current,
                    { x: 0, opacity: 1, width: "auto" },
                    {
                        x: 200,
                        opacity: 0,
                        width: 0,
                        duration: 0.3,
                        ease: "power2.out",
                        scrollTrigger: scrollConfig,
                    }
                );

                gsap.to(navbarRef.current, {
                    width: "50vw",
                    left: "50%",

                    x: "-50%",
                    duration: 0.9,
                    ease: "power2.out",
                    scrollTrigger: scrollConfig,
                });

                gsap.to(navLinksRef.current, {
                    justifyContent: "flex-start",
                    duration: 0.5,
                    ease: "power2.out",
                    scrollTrigger: scrollConfig,
                });

                gsap.to(newLogoRef.current, {
                    x: 0,
                    opacity: 1,
                    width: "auto",
                    duration: 0.6,
                    ease: "power2.out",
                    scrollTrigger: scrollConfig,
                });
            });

            return () => ctx.revert();
        }
    }, []);

    useEffect(() => {
        let ticking = false;

        const updateRotation = () => {
            const theta = document.documentElement.scrollTop / 50 % Math.PI;
            if (newLogoRefRotate.current) {
                newLogoRefRotate.current.style.transform = `rotate(${theta}rad)`;
            }
            ticking = false;
        };

        const onScroll = () => {
            if (!ticking) {
                window.requestAnimationFrame(updateRotation);
                ticking = true;
            }
        };

        window.addEventListener("scroll", onScroll);
        return () => window.removeEventListener("scroll", onScroll);
    }, []);

    return (
        <>
            {/* Desktop Navbar */}
            <div className="desktop_nav">
                <div className="mainnavbar" ref={navbarRef}>
                    <Link to="/" className="main-logo" ref={logoRef}>
                        <div className="logooodiv">
                            <img src="/assets/news.svg" alt="Main Logo" className="navbar__logo" />

                        </div>
                    </Link>

                    <div className="left_side" ref={navLinksRef}>
                        <Link to="/" className="newlogo" ref={newLogoRef}>
                            <div className="logooodiv logodiv2">
                                <img ref={newLogoRefRotate} src="/assets/fff.svg" alt="Main Logo" className="navbar__logo" />

                            </div>
                        </Link>

                        <HashLink to="/#whychooseus" className={activeSection === "whychooseus" ? "active" : ""}>Why Choose Us</HashLink>
                        {/* <HashLink to="/#whatwedo" className={activeSection === "whatwedo" ? "active" : ""}>What We Do</HashLink> */}
                        <Dropdown>
                            <Dropdown.Toggle variant="success" id="dropdown-basic">
                                What We Do
                            </Dropdown.Toggle>

                            <Dropdown.Menu>
                                <Dropdown.Item href="/compliance-governance">Compliance & Governance</Dropdown.Item>
                                <Dropdown.Item href="/managed-it-services">Managed IT Services</Dropdown.Item>
                                <Dropdown.Item href="/security-assessments">Security Assessments</Dropdown.Item>
                                <Dropdown.Item href="/business-process-automation">Business Process Automation</Dropdown.Item>
                                <Dropdown.Item href="/accountant-on-demand">Accountant on Demand</Dropdown.Item>
                            </Dropdown.Menu>
                        </Dropdown>
                        {/* <HashLink to="/#ourwork" className={activeSection === "ourwork" ? "active" : ""}>Our Work</HashLink> */}
                         <Link to="/portfolio" className={location.pathname === "/portfolio" ? "active" : ""}>Portfolio</Link>
                        <Link to="/contactus" className={location.pathname === "/contactus" ? "active" : ""}>Contact Us</Link>
                        <Link to="/coming-soon" className={location.pathname === "/coming-soon" ? "active" : ""}>Blog</Link>
                    </div>
                </div>
            </div>

            {/* Mobile Navbar */}
            <div className="phoneside_div">
                <div className="innnner_phone">
                    <Link to="/">
                        <img src="/assets/logo.svg" alt="Logo" />
                    </Link>
                    <svg onClick={handleShow} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                        <path d="M3 7H21" stroke="white" strokeWidth="1.5" strokeLinecap="round" />
                        <path d="M3 12H21" stroke="white" strokeWidth="1.5" strokeLinecap="round" />
                        <path d="M3 17H21" stroke="white" strokeWidth="1.5" strokeLinecap="round" />
                    </svg>
                </div>
            </div>

            <Offcanvas show={show} onHide={handleClose} className="navbar w-100">
                <Offcanvas.Header>
                    <Offcanvas.Title>
                        <div className="navsidebar">
                            <img src="/assets/logo.svg" alt="Sidebar Logo" />
                            <svg onClick={handleClose} xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
                                <path d="M18 6.61275L6 18.6127" stroke="white" strokeLinecap="round" strokeLinejoin="round" />
                                <path d="M6 6.61275L18 18.6127" stroke="white" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                        </div>
                    </Offcanvas.Title>
                </Offcanvas.Header>
                <Offcanvas.Body>
                    <div>
                        <HashLink to="/#whychooseus" className={activeSection === "whychooseus" ? "active" : ""}>Why Choose Us</HashLink>
                        {/* <HashLink to="/#whatwedo" className={activeSection === "whatwedo" ? "active" : ""}>What We Do</HashLink> */}
                        {/* <HashLink to="/#ourwork" className={activeSection === "ourwork" ? "active" : ""}>Our Work</HashLink> */}
                        <Dropdown>
                            <Dropdown.Toggle variant="success" id="dropdown-basic">
                              What We Do
                            </Dropdown.Toggle>

                            <Dropdown.Menu>
                                <Dropdown.Item href="/compliance-governance">Compliance & Governance</Dropdown.Item>
                                <Dropdown.Item href="/managed-it-services">Managed IT Services</Dropdown.Item>
                                <Dropdown.Item href="/security-assessments">Security Assessments</Dropdown.Item>
                                <Dropdown.Item href="/business-process-automation">Business Process Automation</Dropdown.Item>
                                <Dropdown.Item href="/accountant-on-demand">Accountant on Demand</Dropdown.Item>
                            </Dropdown.Menu>
                        </Dropdown>
                          <Link to="/portfolio" className={location.pathname === "/portfolio" ? "active" : ""}>Portfolio</Link>
                        <Link to="/contactus" className={location.pathname === "/contactus" ? "active" : ""}>Contact Us</Link>
                        <Link to="/coming-soon" className={location.pathname === "/coming-soon" ? "active" : ""}>Blog</Link>
                    </div>
                </Offcanvas.Body>
            </Offcanvas>
        </>
    );
};

export default Headernew;
